import PropTypes from 'prop-types';
import React from 'react';
import { StyleSheet, View, Text } from 'react-native';
import { COLOR, FONT, FONT_SIZE, THEME } from '../../../constants/styles';

import { ParsedText } from '../../components';

export default class MessageText extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps) {
    return this.props.currentMessage.text !== nextProps.currentMessage.text;
  }

  render() {
    const { position, currentMessage, isCaption, isBroadcast, textAtRegexp } = this.props;

    let messageText = currentMessage.text;
    if (isBroadcast) messageText = messageText.replace('((Sent Broadcast))', '');

    const matchers = textAtRegexp
      ? [
          {
            pattern: textAtRegexp,
            style: styles[position].tagStyle,
            renderText: this.props.renderAtLink,
          },
        ]
      : [];

    return (
      <View style={[styles[position].container]}>
        <ParsedText
          style={[
            styles[position].text,
            isCaption ? styles[position].caption : null,
            isBroadcast ? styles.broadcastText : null,
          ]}
          linkStyle={styles[position].link}
          matchers={matchers}
        >
          {messageText}
        </ParsedText>
      </View>
    );
  }
}

const textStyle = {
  fontSize: 16,
  lineHeight: 20,
  marginTop: 5,
  marginBottom: 5,
  marginLeft: 0,
  marginRight: 0,
};

const captionStyle = {
  ...FONT.mediumItalic,
};

const styles = {
  left: StyleSheet.create({
    container: {
      padding: 15,
    },
    text: {
      color: COLOR.text,
      ...textStyle,
    },
    caption: { ...captionStyle },
    link: {
      ...THEME.linkStyle,
    },
    tagStyle: {
      ...THEME.linkStyle,
    },
  }),
  right: StyleSheet.create({
    container: {
      padding: 15,
    },
    text: {
      color: 'white',
      ...textStyle,
    },
    caption: { ...captionStyle },
    link: {
      ...THEME.linkStyle,
      textDecorationLine: 'underline',
      color: 'white',
    },
    tagStyle: {
      ...THEME.linkStyle,
      color: '#0099cc',
    },
  }),
  broadcastText: {
    color: 'white',
  },
};

MessageText.defaultProps = {
  position: 'left',
  currentMessage: {
    text: '',
  },
  textProps: {},
};
